// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1iwZR","title":"styles_title__2jjuQ"};